import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { allHrisIntegrationTypesStateSelector } from '../hris-integration-type-selectors';

import * as Api from '../../api/api';

export const loadHrisIntegrationTypes = () =>
  createGenericDispatcher<Array<HrisIntegrationType>>({
    name: 'LOAD_HRIS_INTEGRATION_TYPES',
    loadFunction: () => Api.get(`/merge/integration-types`),
    args: {},
    shouldExecuteSelector: allHrisIntegrationTypesStateSelector,
  });
